"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDRESS_TYPES = void 0;
var ADDRESS_TYPES = {
  ethereum: 'ethereum',
  ethereumEOA: 'ethereum-eoa',
  erc1271: 'erc1271'
};
exports.ADDRESS_TYPES = ADDRESS_TYPES;